import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/ai-customer-service/page.tsx");
